import React from 'react';
import { call } from '@zipdrug/react-api-sdk';
import _get from 'lodash/get';
import { alertOnError } from '@zipdrug/ui';
import { omit } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import withSelectedPatientId from './withSelectedPatientId';
import withWorkstationPhoneId from './withWorkstationPhoneId';
import withCallCenter from './withCallCenter';
import withRoles from '../hoc/withRoles';

export default ComponentToWrap => {
  return withCallCenter(
    graphql(call.mutateStartOutboundCall, { name: 'mutateStartOutboundCall' })(
      withRoles(
        withSelectedPatientId(
          withWorkstationPhoneId(
            // Inline withHandlers and mapProps functionality
            (props) => {
              // withHandlers logic
              const onCallPhone = to_phone_id => {
                if (
                  _get(props.currentUser, 'feature_flags.callCenter') &&
                  props.isCallCenterActivatedContext
                ) {
                  props.setOutboundToPhoneIdContext(to_phone_id);
                } else {
                  return alertOnError(
                    props.mutateStartOutboundCall({
                      variables: {
                        from_phone_id: props.workstationPhoneId,
                        patient_id: props.selectedPatientId,
                        to_phone_id,
                      },
                    }),
                  );
                }
              };

              // mapProps logic - omit mutateStartOutboundCall and add onCallPhone
              const finalProps = {
                ...omit(props, 'mutateStartOutboundCall'),
                onCallPhone,
              };

              return <ComponentToWrap {...finalProps} />;
            }
          )
        )
      )
    )
  );
};
